/** @format */

export { modelToModelOverviewProps } from './hooks/use-model-to-model-overview';

// eslint-disable-next-line @mpb-com/mpb/barrel-reexports-within-folder, @mpb-com/mpb/no-relative-import-across-modules -- Legacy code: do not use as an example.
export { FavouriteModelButton } from '../search/components/favourite-model-button';

export {
    ModelOverview,
    type ModelOverviewProps,
} from './components/model-overview';

export {
    JOURNEY_ACTION_EVENT,
    ModelJourneyFan,
    type ModelJourneyFanProps,
} from './beta-model-insights/model-journey-fan';

export {
    KitIntelligenceSection,
    type KitIntelligenceSectionProps,
} from './beta-model-insights/kit-intel';

export {
    INSIGHTS_ACTION_EVENT,
    InsightsAction,
    type InsightsActionProps,
} from './beta-model-insights/insights-action';

export { newActionHighlight } from './beta-model-insights/new-action-pulse';
